import API from "@/lib/API";

export const accountService = {
  getAccounts: async (params = {}) => {
    return await API.get('/sd-leads', { params });
  },

  getSalesHeadAccounts: async (params = {}) => {
    return await API.get('/sd-leads/sales-head', { params });
  },

  create: async (data) => {
    return await API.post('/sd-leads', data);
  },

  update: async (id, data) => {
    // If data contains files, use FormData
    const hasFiles = (data.files && Array.isArray(data.files) && data.files.some(f => f instanceof File)) ||
      (data.quotationFile && Array.isArray(data.quotationFile) && data.quotationFile.some(f => f instanceof File));

    if (hasFiles) {
      const formData = new FormData();
      Object.keys(data).forEach(key => {
        if (key === 'files' || key === 'quotationFile') {
          const fileList = data[key];
          if (Array.isArray(fileList)) {
            fileList.forEach(file => {
              if (file instanceof File) {
                formData.append(key, file);
              }
            });
          }
        } else {
          formData.append(key, data[key]);
        }
      });
      return await API.patch(`/sd-leads/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    }
    return await API.patch(`/sd-leads/${id}`, data);
  },

  toggleDisable: async (id, isDisabled) => {
    return await API.patch(`/sd-leads/${id}`, { isDisabled });
  },

  getActivities: async (accountId) => {
    return await API.get(`/sd-leads/${accountId}/activities`);
  },

  addActivity: async (accountId, data) => {
    return await API.post(`/sd-leads/${accountId}/activities`, data);
  },

  getToday: async (params = {}) => {
    return await API.get('/sd-leads', { params: { ...params, date: 'today' } });
  },

  getThisWeek: async (params = {}) => {
    return await API.get('/sd-leads', { params: { ...params, date: 'this_week' } });
  },

  getThisMonth: async (params = {}) => {
    return await API.get('/sd-leads', { params: { ...params, date: 'this_month' } });
  },

  getThisYear: async (params = {}) => {
    return await API.get('/sd-leads', { params: { ...params, date: 'this_year' } });
  },

  getCustomRange: async (fromDate, toDate, params = {}) => {
    return await API.get('/sd-leads', { params: { ...params, fromDate, toDate } });
  },

  getActivityStats: async (params = {}) => {
    const response = await API.get('/sd-leads/stats/activity', { params });
    return response.data?.data || response.data || response;
  }
};




